import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { routeParams } from '../../../../shared/shared.global-service';
import { WorkGridItemObject } from '@it2go/types';

@Injectable()
export class SpecialistRecordListStore extends ComponentStoreV2Factory {

    public works = computed(() => {
        const work = this.data.getWorks();
        const folderId = Number(routeParams.folderId());

        if (work?.items && folderId) {
            const newItems = work.items.map((item: WorkGridItemObject) => ({
                ...item,
                __hideDelete: folderId !== item.folderId,
                __hideDetail: folderId !== item.folderId,
            }));
            return {
                ...work,
                items: newItems,
            };
        }
        return work;
    });

}
